import React from "react";
import { Switch } from "react-router-dom";
import RouteContainer from "./RouteContainer";
import Layout from "./common/Layout";
import LayoutPP from "./common/LayoutPP";
import RedirectRoute from "./RedirectRoute";

import { useSelector } from "react-redux";
import { NotFound, NotFoundContainer } from "./notFound";

import ChangePasswordPage from "./password/ChangePasswordSwitch";
import ForgotPasswordPage from "./password/ForgotPasswordSwitch";
import PasswordResetPage from "./password/PasswordResetPageSwitch";

import ContactPage from "./employee/ContactPage";
import Notification from "./notifications/NotificationPage";
// Employee
import DashboardContainer from "./dashboard/DashboardContainerSwitcher";
import Needhelp from "./employee/needHelp";
import BenefitStatement from "./employee/benefits/BenefitStatementSwitcher";
import BenefitsDocuments from "./employee/benefits/Documents";
import ClaimsDocuments from "./claim/Documents";
import BenefitsSurvey from "./employee/benefits/Survey";
import TotalRewardsStatement from "./employee/benefits/trs";
import NeedHelpArticle from "./employee/needHelpArticle";
import EnrollmentSelectionPage from "./employee/shop/EnrollmentSwitcher";
import ClaimAccountsPage from "./claim/ClaimAccountsSwitcher";
import ClaimDashboard from "./claim/ClaimDashboard";
import ClaimAccountStatementContainer from "./claim/ClaimAccountStatementContainer";
import ClaimEcards from "./claim/ECards";
import UserProfile from "./employee/UserProfileContainerSwitcher";
import AddEditDependantPage from "./dependants/AddEditDependantPage";
import {
  Marketplace,
  ProductPage,
  CategoryPage,
  SearchResultPage,
  ProviderPage,
} from "./marketplace";
import WalletOtherBenefits from "./employee/shop/other-benefits/index.js";
import EnrollmentPreviewPage from "./employee/shop/EnrollmentPreviewSwitcher";
import EnrollmentSuccessPage from "./employee/shop/EnrollmentSuccess";
import SubmitClaimSwitcher from "./claim/SubmitClaimSwitcher";
import AdvancedScreeningResults from "./employee/wellness/advancedScreeningResults";
import PendingClaimsPage from "./claim/PendingClaimsPage";
import TrackClaimsPage from "./claim/TrackClaimsPage";
import ClaimsHistoryPage from "./claim/ClaimsHistoryPage";
import ViewClaimPage from "./claim/ViewClaimPage";
import PreviewClaimPage from "./claim/PreviewClaimPage";
import EditClaimPage from "./claim/EditClaimSwither";
import AddClaimSwitcher from "./claim/AddClaimSwitcher";
import AddDocuments from "./claim/AddDocuments";
import SuccessPage from "./claim/SuccessPage";

import DonationSelectionPage from "./donations/DonationSelectionPage";
import PendingDonationsPage from "./donations/PendingDonationsPage";
import DonationSubmitPage from "./donations/DonationSubmitPage";
import DonationHistoryPage from "./donations/DonationHistoryPage";
import ViewDonationPage from "./donations/ViewDonationPage";
import EditDonationPage from "./donations/EditDonationPage";

import WebsiteMaintenance from "./common/WebsiteMaintenance";
import QRRedirectOS from "./common/QRRedirectOS";
import SinglifeRedirect from "./common/SinglifeRedirect";

// Wellness
import WellnessLaunchpad from "./wellness/wellnessLaunchpad";
import Questionnaire from "./wellness/lifestyleAgeing/questionnaire/answerSomeQuestions";
import HraResult from "./wellness/lifestyleAgeing/results/hraResult";
import PhotoUpload from "./wellness/lifestyleAgeing/photoUploadPage.jsx";
import LibraryCataloguePage from "./elibrary/CataloguePage";
import LibraryItemPage from "./elibrary/CatalogueItemDetailPage";
import Activities from "./wellness/activities/activities";
import ActivityDetailsPage from "./wellness/activities/activityDetails";
import MentalWellnessPage from "./wellness/MentalWellness";

// Delegation
import { DelegationPage, SearchDelegationPage } from "./employee/delegation";

import AddEditDelegationContainer from "./employee/delegation/AddEditDelegationContainer";

// In-App Messages
import { InAppMessagesHomePage } from "./inAppMessages";

import { SetupTwoFAPage } from "./twoFA";

import Newsletters from "./wellness/Newsletters";
import Newsletter from "./wellness/NewsletterPage";
import ClinicsPage from "./claim/ClinicsPage.js";

const routes = (
  <Switch>
    <RouteContainer exact path="/forgotPassword" component={ForgotPasswordPage} />
    <RouteContainer exact path="/resetPassword" component={PasswordResetPage} />

    <RouteContainer exact path="/setup2fa" component={SetupTwoFAPage} />
    <RouteContainer exact path="/contact" component={ContactPage} />

    <RouteContainer requireAuth exact path="/dashboard" component={DashboardContainer} />

    <RouteContainer requireAuth exact path="/marketplace" component={Marketplace} />

    <RouteContainer
      requireAuth
      exact
      path="/marketplace/category/:categoryId"
      component={CategoryPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/marketplace/product/:productId"
      component={ProductPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/marketplace/provider/:providerId"
      component={ProviderPage}
    />
    <RouteContainer requireAuth exact path="/marketplace/search" component={SearchResultPage} />
    <RedirectRoute exact path="/shop" to="/shop/enrolment" />
    <RouteContainer requireAuth exact path="/shop/enrolment" component={EnrollmentSelectionPage} />
    <RouteContainer requireAuth exact path="/shop/checkout" component={EnrollmentPreviewPage} />
    <RouteContainer
      requireAuth
      exact
      path="/shop/checkout/success"
      component={EnrollmentSuccessPage}
    />

    <RedirectRoute
      exact
      path="/wellness/lifestyleAgeing"
      to="/wellness/lifestyleAgeing/ageYourSelf"
    />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/lifestyleAgeing/ageYourSelf"
      component={PhotoUpload}
    />
    <RedirectRoute exact path="/wellness" to="/wellness/launchpad" />
    <RouteContainer requireAuth exact path="/wellness/launchpad" component={WellnessLaunchpad} />
    <RouteContainer requireAuth exact path="/wellness/mentalWellness" component={MentalWellnessPage} />
    <RedirectRoute
      exact
      path="/wellness/lifestyleAgeing/questionnaire"
      to="/wellness/lifestyleAgeing/questionnaire/1"
    />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/lifestyleAgeing/questionnaire/:page"
      component={Questionnaire}
    />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/lifestyleAgeing/results"
      component={HraResult}
    />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/screening-results/advanced"
      component={AdvancedScreeningResults}
    />
    <RouteContainer requireAuth exact path="/wellness/activities" component={Activities} />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/activities/:activityId/:signupId"
      component={ActivityDetailsPage}
    />

    <RedirectRoute exact path="/wellness/elibrary" to="/wellness/elibrary/catalogue" />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/elibrary/catalogue"
      component={LibraryCataloguePage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/wellness/elibrary/catalogue/:itemId"
      component={LibraryItemPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/marketplace/product/:productId"
      component={ProductPage}
    />
    <RouteContainer requireAuth exact path="/wellness/newsletters" component={Newsletters} />
    <RouteContainer requireAuth exact path="/wellness/newsletters/:id" component={Newsletter} />

    <RouteContainer exact path="/benefits" />
    <RouteContainer requireAuth exact path="/benefits/statement" component={BenefitStatement} />
    <RouteContainer requireAuth exact path="/benefits/documents" component={BenefitsDocuments} />
    <RouteContainer requireAuth exact path="/benefits/survey" component={BenefitsSurvey} />
    <RouteContainer requireAuth exact path="/benefits/eCards" component={ClaimEcards} />
    <RouteContainer
      requireAuth
      exact
      path="/benefits/reward-statement"
      component={TotalRewardsStatement}
    />
    <RouteContainer
      requireAuth
      exact
      path="/benefits/otherbenefits"
      component={WalletOtherBenefits}
    />
    <RouteContainer exact path="/claims" component={ClaimDashboard} />
    <RouteContainer requireAuth exact path="/claims/accounts" component={ClaimAccountsPage} />
    <RouteContainer
      requireAuth
      exact
      path="/claims/accounts/:benefitPeriod/:accountType/:benefitPeriodEnd?"
      component={ClaimAccountStatementContainer}
    />
    <RouteContainer requireAuth exact path="/benefits/clinics" component={ClinicsPage} />
    <RouteContainer requireAuth exact path="/claims/clinics" component={ClinicsPage} />
    <RouteContainer requireAuth exact path="/claims/history" component={ClaimsHistoryPage} />
    <RouteContainer requireAuth exact path="/claims/pending" component={PendingClaimsPage} />
    <RouteContainer requireAuth exact path="/claims/track" component={TrackClaimsPage} />
    <RouteContainer requireAuth exact path="/claims/submit" component={SubmitClaimSwitcher} />
    <RouteContainer requireAuth exact path="/claims/documents" component={ClaimsDocuments} />
    <RouteContainer requireAuth exact path="/claims/eCards" component={ClaimEcards} />
    <RouteContainer
      requireAuth
      exact
      path="/claims/submit/:claimTypeId/:benefitPeriod/:selectedDelegator?"
      component={AddClaimSwitcher}
    />
    <RouteContainer
      requireAuth
      exact
      path="/claims/view/:claimId/:selectedDelegator?"
      component={ViewClaimPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/claims/preview/:claimId/:selectedDelegator?"
      component={PreviewClaimPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/claims/edit/:claimId/:selectedDelegator?"
      component={EditClaimPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/claims/documents/:claimId/:selectedDelegator?"
      component={AddDocuments}
    />
    <RouteContainer
      requireAuth
      exact
      path="/claims/:claimId/success/:selectedDelegator?"
      component={SuccessPage}
    />
    <RedirectRoute exact path="/donations" to="/donations/submit" />
    <RouteContainer requireAuth exact path="/donations/history" component={DonationHistoryPage} />
    <RouteContainer requireAuth exact path="/donations/pending" component={PendingDonationsPage} />
    <RouteContainer requireAuth exact path="/donations/submit" component={DonationSelectionPage} />
    <RouteContainer
      requireAuth
      exact
      path="/donations/submit/:claimTypeId/:benefitPeriod/:selectedDelegator?"
      component={DonationSubmitPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/donations/view/:claimId/:selectedDelegator?"
      component={ViewDonationPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/donations/edit/:claimId/:selectedDelegator?"
      component={EditDonationPage}
    />
    <RouteContainer requireAuth exact path="/delegation" component={DelegationPage} />
    <RouteContainer requireAuth exact path="/delegation/search" component={SearchDelegationPage} />
    <RouteContainer
      requireAuth
      exact
      path="/delegation/add/:employeeKey/:employeeName"
      component={AddEditDelegationContainer}
    />
    <RouteContainer
      requireAuth
      exact
      path="/delegation/edit/:employeeKey/:employeeName/:entityKey"
      component={AddEditDelegationContainer}
    />

    <RouteContainer requireAuth exact path="/userProfile" component={UserProfile} />
    <RouteContainer requireAuth exact path="/userProfile/edit" component={UserProfile} />
    <RouteContainer requireAuth exact path="/notifications" component={Notification} />
    <RouteContainer requireAuth exact path="/changePassword" component={ChangePasswordPage} />
    <RouteContainer requireAuth exact path="/dependants/add" component={AddEditDependantPage} />
    <RouteContainer
      requireAuth
      exact
      path="/dependants/:dependantId/edit"
      component={AddEditDependantPage}
    />

    <RouteContainer requireAuth exact path="/messages" component={InAppMessagesHomePage} />
    <RouteContainer requireAuth exact path="/needhelp" component={Needhelp} />
    <RouteContainer
      requireAuth
      exact
      path="/needHelpArticle/:articleId"
      component={NeedHelpArticle}
    />

    <RouteContainer exact path="/404" component={NotFoundContainer} />
    <RouteContainer exact path="/website-maintenance" component={WebsiteMaintenance} />
    <RouteContainer exact path="/qr-redirect-os" component={QRRedirectOS} />
    <RouteContainer exact path="/singlife-redirect" component={SinglifeRedirect} />

    <RouteContainer component={NotFound} />
  </Switch>
);

const AuthRoutes = props => {
  const clientSettings = useSelector(state => state.common.clientSettings);
  return clientSettings && clientSettings.newUIFlag ? (
    <LayoutPP {...props}>{routes}</LayoutPP>
  ) : (
    <Layout {...props}>{routes}</Layout>
  );
};

export default AuthRoutes;



// WEBPACK FOOTER //
// ./components/AuthRoutes.jsx